import { render, staticRenderFns } from "./work-header.vue?vue&type=template&id=27cde73a&scoped=true"
import script from "./work-header.vue?vue&type=script&lang=ts"
export * from "./work-header.vue?vue&type=script&lang=ts"
import style0 from "./work-header.vue?vue&type=style&index=0&id=27cde73a&prod&lang=less&scoped=true"
import style1 from "./work-header.vue?vue&type=style&index=1&id=27cde73a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27cde73a",
  null
  
)

export default component.exports